import React from 'react'
import { css } from '@emotion/core'

const bulletListCss = css`
  padding-inline-start: 26px;
  & > li {
    display: list-item;
  }
`

export default function BulletList({ children }) {
  return <ul css={bulletListCss}>{children}</ul>
}
